import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from '../config/axiosInstance';

const DomainEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [formData, setFormData] = useState({
        domain: '',
        code: '',
        service_code: [],
        feature_list: []
    });
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [featureText, setFeatureText] = useState('');
    const [serviceCodeText, setServiceCodeText] = useState('');

    useEffect(() => {
        fetchDomain();
    }, [id]);

    const fetchDomain = async () => {
        try {
            const response = await axiosInstance.get(`/domains/detail/${id}`);
            setFormData(response.data?.data);
            setFeatureText(response.data?.data?.feature_list?.join(', ') || '');
            setServiceCodeText(response.data?.data?.service_code?.join(', ') || '');
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch domain');
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFeatureTextChange = (e) => {
        setFeatureText(e.target.value);
    };

    const handleServiceCodeTextChange = (e) => {
        setServiceCodeText(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Convert comma-separated text to array and trim spaces
            const features = featureText
                .split(',')
                .map(feature => feature.trim())
                .filter(feature => feature.length > 0);

            const serviceCodes = serviceCodeText
                .split(',')
                .map(code => code.trim())
                .filter(code => code.length > 0);

            const formDataToSend = new FormData();
            formDataToSend.append('domain', formData.domain);
            formDataToSend.append('code', formData.code);
            
            if (serviceCodes.length > 0) {
                serviceCodes.forEach(code => {
                    formDataToSend.append('service_code[]', code);
                });
            }

            if (features.length > 0) {
                features.forEach(feature => {
                    formDataToSend.append('feature_list[]', feature);
                });
            }

            await axiosInstance.post(`/domains/update/${id}`, formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            navigate('/portal/domains');
        } catch (err) {
            setError('Failed to update domain');
        }
    };

    if (loading) return <div>Loading...</div>;

    return (
        <div className="container-fluid">
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h3 mb-0 text-gray-800">Edit Domain</h1>
            </div>

            <div className="card shadow mb-4">
                <div className="card-body">
                    {error && <div className="alert alert-danger">{error}</div>}
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="domain">Domain</label>
                            <input
                                type="text"
                                className="form-control"
                                id="domain"
                                name="domain"
                                value={formData.domain}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="code">Code</label>
                            <input
                                type="text"
                                className="form-control"
                                id="code"
                                name="code"
                                value={formData.code}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="service_code">Service Codes (comma-separated)</label>
                            <textarea
                                className="form-control"
                                id="service_code"
                                name="service_code"
                                value={serviceCodeText}
                                onChange={handleServiceCodeTextChange}
                                placeholder="Enter service codes separated by commas"
                                rows="3"
                            />
                            <small className="form-text text-muted">
                                Enter service codes separated by commas
                            </small>
                        </div>
                        <div className="form-group">
                            <label htmlFor="feature_list">Features (comma-separated)</label>
                            <textarea
                                className="form-control"
                                id="feature_list"
                                name="feature_list"
                                value={featureText}
                                onChange={handleFeatureTextChange}
                                placeholder="Enter features separated by commas (e.g., coin_identify, coin_discovery)"
                                rows="3"
                            />
                            <small className="form-text text-muted">
                                Enter features separated by commas. Example: coin_identify, coin_discovery
                            </small>
                        </div>
                        <button type="submit" className="btn btn-primary">Update Domain</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default DomainEdit; 